import React, { useState, useEffect } from 'react'
import ProfileCard from '../common/profileCard'
import StudentSidebar from '../common/studentSidebar'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { all_routes } from '../../router/all_routes'
import { getUserDashboard, UserDashboardResponse } from '../../../api/user'

const StudentDashboard = () => {
  const [
    dashboardData,
    setDashboardData,
  ] = useState<UserDashboardResponse | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    // Fetch dashboard data
    getUserDashboard()
      .then((data) => {
        setDashboardData(data)
        setLoading(false)
        // For development: log the data structure
        console.log('Dashboard data:', data)
      })
      .catch((err) => {
        setError('Gagal memuat data dashboard')
        setLoading(false)
        console.error(err)
      })
  }, [])

  // Helper function to check if live teaching is upcoming (based on start_date)
  const isUpcomingLiveTeaching = (liveTeaching: any) => {
    if (!liveTeaching?.start_date) return false
    const start = new Date(liveTeaching.start_date)
    return start.getTime() >= Date.now()
  }

  // Get upcoming live teaching sessions
  const upcomingLiveTeaching = (
    dashboardData?.live_teaching?.filter(isUpcomingLiveTeaching) || []
  )
    .sort(
      (a: any, b: any) =>
        new Date(a.start_date).getTime() - new Date(b.start_date).getTime(),
    )
    .slice(0, 1)

  const nextLiveTeaching = upcomingLiveTeaching[0] || null

  const [remainingMs, setRemainingMs] = useState<number | null>(null)

  useEffect(() => {
    if (!nextLiveTeaching?.start_date) {
      setRemainingMs(null)
      return
    }

    const startTime = new Date(nextLiveTeaching.start_date).getTime()

    const tick = () => {
      const diff = startTime - Date.now()
      setRemainingMs(diff > 0 ? diff : 0)
    }

    tick()
    const intervalId = setInterval(tick, 1000)
    return () => clearInterval(intervalId)
  }, [nextLiveTeaching?.start_date])

  const formatDuration = (ms: number) => {
    const totalSeconds = Math.floor(ms / 1000)
    const days = Math.floor(totalSeconds / 86400)
    const hours = Math.floor((totalSeconds % 86400) / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    const pad = (n: number) => n.toString().padStart(2, '0')

    const hhmmss = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
    return days > 0 ? `${days} hari ${hhmmss}` : hhmmss
  }

  return (
    <>
      <div className="content">
        <div className="container">
          {/* profile box */}
          <ProfileCard />
          {/* profile box */}
          <div className="row">
            {/* sidebar */}
            <StudentSidebar />
            {/* sidebar */}
            <div className="col-lg-9">
              {loading ? (
                <div className="text-center my-5">Loading...</div>
              ) : error ? (
                <div className="alert alert-danger my-5">{error}</div>
              ) : (
                <>
                  <div className="row">
                    <div className="col-md-6 col-xl-4">
                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <span className="icon-box bg-primary-transparent me-2 me-xxl-3 flex-shrink-0">
                              <ImageWithBasePath
                                src="/assets/img/icon/graduation.svg"
                                alt=""
                              />
                            </span>
                            <div>
                              <span className="d-block">Live Teaching</span>
                              <h4 className="fs-24 mt-1">
                                {dashboardData?.live_teaching_count ?? 0}
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <span className="icon-box bg-secondary-transparent me-2 me-xxl-3 flex-shrink-0">
                              <ImageWithBasePath
                                src="/assets/img/icon/book.svg"
                                alt=""
                              />
                            </span>
                            <div>
                              <span className="d-block">Jadi Course</span>
                              <h4 className="fs-24 mt-1">
                                {dashboardData?.course_count ?? 0}
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <span className="icon-box bg-success-transparent me-2 me-xxl-3 flex-shrink-0">
                              <ImageWithBasePath
                                src="/assets/img/icon/bookmark.svg"
                                alt=""
                              />
                            </span>
                            <div>
                              <span className="d-block">Jadi UKOM</span>
                              <h4 className="fs-24 mt-1">
                                {dashboardData?.cbt_count ?? 0}
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Countdown Card for Upcoming Live Teaching */}
                  {upcomingLiveTeaching.length > 0 && (
                    <div className="card bg-light quiz-ans-card mb-4">
                      <ImageWithBasePath
                        src="/assets/img/shapes/withdraw-bg1.svg"
                        className="quiz-ans-bg1"
                        alt="img"
                      />
                      <ImageWithBasePath
                        src="/assets/img/shapes/withdraw-bg2.svg"
                        className="quiz-ans-bg2"
                        alt="img"
                      />
                      <div className="card-body">
                        {/* Countdown Timer */}
                        <div className="mb-3">
                          <span className="badge bg-warning text-dark fs-14">
                            {remainingMs !== null
                              ? `Live Teaching mulai dalam: ${formatDuration(
                                remainingMs,
                              )}`
                              : 'Jadwal Live Teaching belum tersedia'}
                          </span>
                        </div>
                        <div className="row align-items-center">
                          <div className="col-md-8">
                            <div>
                              <h6 className="mb-1">
                                {nextLiveTeaching?.title ||
                                  'Live Teaching Session'}
                              </h6>
                              <p>
                                {nextLiveTeaching?.start_date
                                  ? new Date(
                                    nextLiveTeaching.start_date,
                                  ).toLocaleString('id-ID', {
                                    weekday: 'long',
                                    day: '2-digit',
                                    month: 'long',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: false,
                                  }) + ' WIB'
                                  : '-'}
                              </p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="text-end">
                              <Link
                                to={
                                  nextLiveTeaching?.id
                                    ? all_routes.studentLiveEventDetails.replace(
                                      ':id',
                                      String(nextLiveTeaching.id),
                                    )
                                    : '#'
                                }
                                className="btn btn-primary rounded-pill"
                              >
                                Gabung Kelas
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <h5 className="mb-3 fs-18">Akses Course Kamu</h5>
                  <div className="row">
                    {dashboardData?.course &&
                      dashboardData.course.length > 0 ? (
                      dashboardData.course.map((item: any, idx: number) => (
                        <div className="col-xl-4 col-md-6" key={item.id}>
                          <div className="course-item-two course-item mx-0">
                            <div className="course-img">
                              <Link
                                to={
                                  item?.id
                                    ? all_routes.studentCourseContent.replace(
                                      ':id',
                                      String(item.id),
                                    )
                                    : '#'
                                }
                              >
                                <ImageWithBasePath
                                  srcApi={item.image}
                                  src=""
                                  alt="img"
                                  className="img-fluid"
                                  fallbackSrc="/assets/img/course/course-48.jpg"
                                />
                              </Link>
                              <div className="position-absolute start-0 top-0 d-flex align-items-start w-100 z-index-2 p-3"></div>
                            </div>
                            <div className="course-content">
                              <div className="d-flex justify-content-between mb-2">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avatar-sm">
                                    <ImageWithBasePath
                                      src="/assets/img/user/user-29.jpg"
                                      alt="img"
                                      className="img-fluid avatar avatar-sm rounded-circle"
                                    />
                                  </span>
                                  <div className="ms-2">
                                    <span className="link-default fs-14">
                                      {item.category?.name || '-'}
                                    </span>
                                  </div>
                                </div>
                                <span className="badge badge-light rounded-pill bg-light d-inline-flex align-items-center fs-13 fw-medium mb-0">
                                  {item.type}
                                </span>
                              </div>
                              <h6 className="title mb-2">
                                <Link
                                  to={
                                    item?.id
                                      ? all_routes.studentCourseContent.replace(
                                        ':id',
                                        String(item.id),
                                      )
                                      : '#'
                                  }
                                >
                                  {item.title}
                                </Link>
                              </h6>
                              <p className="d-flex align-items-center mb-3">
                                <i className="fa-solid fa-star text-warning me-2" />
                                {/* Rating not available in API, placeholder */}
                                -
                              </p>
                              <div className="d-flex align-items-center justify-content-between">
                                <h5 className="text-secondary mb-0">
                                  Rp
                                  {parseInt(item.price).toLocaleString('id-ID')}
                                </h5>
                                <Link
                                  to={
                                    item?.id
                                      ? all_routes.studentCourseContent.replace(
                                        ':id',
                                        String(item.id),
                                      )
                                      : '#'
                                  }
                                  className="btn btn-dark btn-sm d-inline-flex align-items-center"
                                >
                                  Lihat Detail
                                  <i className="isax isax-arrow-right-3 ms-1" />
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-12 text-center text-muted">
                        Belum ada course
                      </div>
                    )}
                  </div>

                  {/* CBT History Section */}
                  <div className="row mt-4">
                    <div className="col-xl-12">
                      <div className="card mb-0">
                        <div className="card-body">
                          <h5 className="mb-3 fs-18 border-bottom pb-3">
                            Riwayat Ujian Kamu
                          </h5>
                          {dashboardData?.CBT &&
                            dashboardData.CBT.length > 0 ? (
                            dashboardData.CBT.map((cbt: any) => (
                              <div
                                key={cbt.id}
                                className="d-flex align-items-center flex-wrap flex-md-nowrap justify-content-between row-gap-2 mb-3"
                              >
                                <div>
                                  <h6 className="mb-1">{cbt.title}</h6>
                                  <div className="d-flex align-items-center">
                                    <p className="mb-0">
                                      Dibeli pada:{' '}
                                      {cbt.updated_at
                                        ? new Date(
                                          cbt.updated_at,
                                        ).toLocaleString('id-ID', {
                                          day: '2-digit',
                                          month: 'long',
                                          year: 'numeric',
                                          hour: '2-digit',
                                          minute: '2-digit',
                                          hour12: false,
                                        })
                                        : '-'}
                                    </p>
                                  </div>
                                </div>
                                <div>
                                  {cbt.is_answered && (
                                    <Link
                                      to={all_routes.studentCBTList.replace(':id', String(cbt.id))}
                                      className="btn btn-success me-2"
                                    >
                                      Lihat Review
                                    </Link>
                                  )}
                                  {!cbt.is_finished && (
                                    <Link
                                      to={all_routes.studentCBTInstruction.replace(
                                        ':id',
                                        String(cbt.id))}
                                      className="btn btn-primary"
                                    >
                                      Mulai
                                    </Link>
                                  )}
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="text-muted">
                              Belum ada riwayat ujian
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default StudentDashboard
